import { type IHttpApi } from '@cian/http-api/shared';
import { type ILogger } from '@cian/logger/shared';

import { ResponseError } from '../../errors';
import { fetchGetQuickLinks, TGetQuickLinksResponse } from '../../repositories/seo-crosslinks/v1/get-quick-links';
import { IQuickLinksTab } from '../../types/quickLinks';

interface IFetchQuickLinksParameters {
  subdomain: string;
  path: string;
}

interface IContext {
  httpApi: IHttpApi;
  logger: ILogger;
}

async function fetchQuickLinks(
  { httpApi }: IContext,
  { subdomain, path }: IFetchQuickLinksParameters,
): Promise<IQuickLinksTab[]> {
  const quickLinks: TGetQuickLinksResponse = await fetchGetQuickLinks({
    httpApi,
    parameters: {
      geoSubdomain: subdomain,
      seoUrl: path,
    },
  });

  if (quickLinks.statusCode !== 200) {
    throw new ResponseError({
      domain: 'fetchQuickLinks',
      message: quickLinks.response.message || '',
      details: {
        error: JSON.stringify(quickLinks.response.errors),
      },
    });
  }

  return quickLinks.response.tabs;
}

export async function fetchQuickLinksSafe(
  context: IContext,
  parameters: IFetchQuickLinksParameters,
): Promise<IQuickLinksTab[] | null> {
  try {
    return await fetchQuickLinks(context, parameters);
  } catch (ex) {
    const { logger } = context;

    logger.warning(ex, { degradation: 'Быстрые ссылки' });

    return null;
  }
}
